/**
 * #form.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { FormField } from "./field.js";
function createBaseForm() {
    return {
        fields: [],
        title: undefined,
        shortDescription: undefined,
        acceptLabel: undefined,
        cancelLabel: undefined,
        id: undefined,
    };
}
export const Form = {
    $type: "devvit.ui.form_builder.v1alpha.Form",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.fields) {
            FormField.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.title !== undefined) {
            writer.uint32(18).string(message.title);
        }
        if (message.shortDescription !== undefined) {
            writer.uint32(26).string(message.shortDescription);
        }
        if (message.acceptLabel !== undefined) {
            writer.uint32(34).string(message.acceptLabel);
        }
        if (message.cancelLabel !== undefined) {
            writer.uint32(42).string(message.cancelLabel);
        }
        if (message.id !== undefined) {
            writer.uint32(50).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseForm();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.fields.push(FormField.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.title = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.shortDescription = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.acceptLabel = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.cancelLabel = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            fields: globalThis.Array.isArray(object?.fields) ? object.fields.map((e) => FormField.fromJSON(e)) : [],
            title: isSet(object.title) ? globalThis.String(object.title) : undefined,
            shortDescription: isSet(object.shortDescription) ? globalThis.String(object.shortDescription) : undefined,
            acceptLabel: isSet(object.acceptLabel) ? globalThis.String(object.acceptLabel) : undefined,
            cancelLabel: isSet(object.cancelLabel) ? globalThis.String(object.cancelLabel) : undefined,
            id: isSet(object.id) ? globalThis.String(object.id) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.fields?.length) {
            obj.fields = message.fields.map((e) => FormField.toJSON(e));
        }
        if (message.title !== undefined) {
            obj.title = message.title;
        }
        if (message.shortDescription !== undefined) {
            obj.shortDescription = message.shortDescription;
        }
        if (message.acceptLabel !== undefined) {
            obj.acceptLabel = message.acceptLabel;
        }
        if (message.cancelLabel !== undefined) {
            obj.cancelLabel = message.cancelLabel;
        }
        if (message.id !== undefined) {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return Form.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseForm();
        message.fields = object.fields?.map((e) => FormField.fromPartial(e)) || [];
        message.title = object.title ?? undefined;
        message.shortDescription = object.shortDescription ?? undefined;
        message.acceptLabel = object.acceptLabel ?? undefined;
        message.cancelLabel = object.cancelLabel ?? undefined;
        message.id = object.id ?? undefined;
        return message;
    },
};
messageTypeRegistry.set(Form.$type, Form);
function isSet(value) {
    return value !== null && value !== undefined;
}
